// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7cebb269","455":"f8ac16c7"}[chunkId] + ".chunk.js";
};